import { signal, computed } from "@preact/signals";
import { createAddressSignal } from "./address";

/**
 * Creates a signal from a unified shipping object
 * @param {Shipping} data
 * @returns
 */
export function createShippingSignal(data) {
  const firstName = signal(data?.firstName || "");
  const lastName = signal(data?.lastName || "");
  const companyName = signal(data?.companyName || "");
  const phone = signal(data?.phone || "");
  const email = signal(data?.email || "");

  const address = signal(createAddressSignal(data?.address || {}));

  const shipping = computed(() => {
    const shippingObject = {};

    if (firstName.value) {
      shippingObject.firstName = firstName.value;
    }
    if (lastName.value) {
      shippingObject.lastName = lastName.value;
    }
    if (companyName.value) {
      shippingObject.companyName = companyName.value;
    }
    if (phone.value) {
      shippingObject.phone = phone.value;
    }
    if (email.value) {
      shippingObject.email = email.value;
    }
    if (address.value?.address?.value) {
      shippingObject.address = address.value.address.value;
    }

    return shippingObject;
  });

  return {
    firstName,
    lastName,
    companyName,
    phone,
    email,
    address,
    shipping,
  };
}
